import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'modal-success-donaciones',
    templateUrl: './modal-success-donacion.component.html'
})
export class ModalSuccessDonacionComponent implements OnInit {
    // @Input('vlrDonacionPesosFinal') vlrDonacionPesosFinal: string;
    // @Input('vlrDonacionPinosFinal') vlrDonacionPinosFinal: string;


    constructor(
        public activeModal: NgbActiveModal
    ) { 
        // console.log("llego",this.vlrDonacionPesosFinal);
    }


    ngOnInit() {
        console.log("hola");
    }

    aceptarMensaje() {
        this.activeModal.close(true);
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/modal-success-donacion/modal-success-donacion.component.ts